interface IAuthCredentials {
    userName?: string;
}

export interface IAuthResponse {
    code?: number;
    type?: string;
    message?: string;
}

export type TAuthResponseWithCredentials = IAuthCredentials & IAuthResponse & {isPortal2faAuth?: boolean};

export interface IAuthError {
    message?: string;
    code?: number;
    type?: string;
}

export interface IUserInfo extends IAuthCredentials {
    fullName: string;
    externalEmployee: boolean | null;
    userId: number;
}

export interface IAuthSliceState {
    userName?: string;
    isAuthenticated: boolean;
    error?: IAuthError | null;
    isPasswordExpired?: boolean;
    isPasswordSuccessfullyChanged?: boolean;
    userInfo?: IUserInfo;
    useTwoFAVerificationFlag?: boolean;
    twoFactorAuthTypeCode?: ETwoFactorAuthCode;
    profile?: EAuthProfile | null;
    microserviceToken?: string | null;
    twoFaCodeValidity?: number;
}

export interface ITwoFactorAuthStatus {
    message?: string;
    isError?: boolean;
}

export enum ETwoFactorAuthCode {
    GOOGLE = 'UseGoogle2fa',
    CUSTOM = 'UseCustom2fa',
    PORTAL = 'UsePortal2fa',
}

export interface IChangePasswordSettings {
    minLengthPwd: string;
    maxLengthPwd: string;
    allowedCharactersInPassword: string;
}

export enum EAuthProfile {
    LDAP = 'ldap',
    SAML = 'saml',
    KEYCLOAK = 'keycloak',
    KERBEROS = 'kerberos',
}
